'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createReactions;

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _mapValues = require('lodash/mapValues');

var _mapValues2 = _interopRequireDefault(_mapValues);

var _isEqual = require('lodash/isEqual');

var _isEqual2 = _interopRequireDefault(_isEqual);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function addToManyProperty(state, action, relation) {
  var foreignEntity = action.payload.entity;
  var through = relation.through,
      foreign = relation.foreign;

  var entityToUpdate = (0, _get2.default)(state, (0, _get2.default)(foreignEntity, foreign));
  if (!entityToUpdate) {
    // Don't do anything if the parent entity doesn't exist
    return state;
  }
  if ((0, _get2.default)(entityToUpdate, through, []).find(function (id) {
    return id == foreignEntity.id;
  })) {
    return state; // Don't do anything if the entity is already on the state
  }
  return _extends({}, state, _defineProperty({}, entityToUpdate.id, _extends({}, entityToUpdate, _defineProperty({}, through, [].concat(_toConsumableArray((0, _get2.default)(entityToUpdate, through, [])), [foreignEntity.id])))));
}

function deleteFromManyProperty(state, action, relation) {
  var foreignEntity = action.payload.entity;
  var through = relation.through,
      foreign = relation.foreign;

  var entityToUpdate = (0, _get2.default)(state, (0, _get2.default)(foreignEntity, foreign));
  if (!entityToUpdate) {
    // Don't do anything if the parent entity doesn't exist
    return state;
  }
  return _extends({}, state, _defineProperty({}, entityToUpdate.id, _extends({}, entityToUpdate, _defineProperty({}, through, (0, _get2.default)(entityToUpdate, through, []).filter(function (id) {
    return id != foreignEntity.id;
  })))));
}

function updateRelation(state, action, relation) {
  var _action$payload = action.payload,
      foreignEntity = _action$payload.entity,
      oldForeignEntity = _action$payload.oldEntity;
  var through = relation.through,
      foreign = relation.foreign;

  if ((0, _get2.default)(foreignEntity, foreign) === undefined || (0, _isEqual2.default)((0, _get2.default)(foreignEntity, foreign), (0, _get2.default)(oldForeignEntity, foreign))) {
    return state; // No need to update because the prop has not been updated
  }
  var newParentEntitiesIds = (0, _utils.arrayFrom)((0, _get2.default)(foreignEntity, foreign));
  var oldParentEntitiesIds = (0, _utils.arrayFrom)((0, _get2.default)(oldForeignEntity, foreign));
  return (0, _mapValues2.default)(state, function (entity) {
    var id = entity.id;
    if (newParentEntitiesIds.includes(id) && (0, _get2.default)(entity, through).find(function (id) {
      return id == foreignEntity.id;
    }) === undefined) {
      return _extends({}, entity, _defineProperty({}, through, [].concat(_toConsumableArray((0, _get2.default)(entity, through, [])), [foreignEntity.id])));
    }
    if (oldParentEntitiesIds.includes(id) && !newParentEntitiesIds.includes(entity.id)) {
      return _extends({}, entity, _defineProperty({}, through, (0, _get2.default)(entity, through, []).filter(function (id) {
        return id != foreignEntity.id;
      })));
    }
    return entity;
  });
}

function updateRelatedId(state, action, relation) {
  var _action$payload2 = action.payload,
      newId = _action$payload2.newId,
      oldId = _action$payload2.oldId;
  var isMany = relation.isMany,
      through = relation.through;

  if (isMany) {
    return (0, _mapValues2.default)(state, function (entity) {
      return _extends({}, entity, _defineProperty({}, through, (0, _get2.default)(entity, through, []).map(function (id) {
        return id == oldId ? newId : id;
      })));
    });
  } else {
    return (0, _mapValues2.default)(state, function (entity) {
      return _extends({}, entity, _defineProperty({}, through, (0, _get2.default)(entity, through) == oldId ? newId : (0, _get2.default)(entity, through)));
    });
  }
}

function deleteOneProperty(state, action, relation) {
  var foreignEntity = action.payload.entity;
  var through = relation.through;

  return (0, _mapValues2.default)(state, function (entity) {
    return _extends({}, entity, _defineProperty({}, through, (0, _get2.default)(entity, through) == foreignEntity.id ? null : (0, _get2.default)(entity, through)));
  });
}

function createOneRelationReactions(relation) {
  var _ref;

  var to = relation.to;

  return _ref = {}, _defineProperty(_ref, '@@entman/DELETE_ENTITY_' + to.toUpperCase(), function undefined(state, action) {
    return deleteOneProperty(state, action, relation);
  }), _defineProperty(_ref, '@@entman/UPDATE_ENTITY_ID_' + to.toUpperCase(), function undefined(state, action) {
    return updateRelatedId(state, action, relation);
  }), _ref;
}

function createManyRelationReactions(relation) {
  var _ref2;

  var to = relation.to;

  return _ref2 = {}, _defineProperty(_ref2, '@@entman/CREATE_ENTITY_' + to.toUpperCase(), function undefined(state, action) {
    return addToManyProperty(state, action, relation);
  }), _defineProperty(_ref2, '@@entman/DELETE_ENTITY_' + to.toUpperCase(), function undefined(state, action) {
    return deleteFromManyProperty(state, action, relation);
  }), _defineProperty(_ref2, '@@entman/UPDATE_ENTITY_' + to.toUpperCase(), function undefined(state, action) {
    return updateRelation(state, action, relation);
  }), _defineProperty(_ref2, '@@entman/UPDATE_ENTITY_ID_' + to.toUpperCase(), function undefined(state, action) {
    return updateRelatedId(state, action, relation);
  }), _ref2;
}

// The entity in state reacts to the entity in relation
function createReactionsToRelation(relation) {
  if (relation.isMany) {
    // relation is going to be an array (e.g. users)
    return createManyRelationReactions(relation);
  } else {
    return createOneRelationReactions(relation);
  }
}

function createReactions(relations) {
  return relations.map(createReactionsToRelation).reduce(function (memo, reactions) {
    return _extends({}, memo, reactions);
  }, {});
}